import { Directive } from '@angular/core';
import { PopupCloseEvent, SinglePopupService } from '@progress/kendo-angular-grid';

@Directive({
  selector: '[kendoGridFilterMenuMonitor]',
})
export class KendoGridFilterMenuMonitor {
  constructor(private singlePopupService: SinglePopupService) {
    this.monitorGridFilterMenuForClickOutside();
  }

  // stops the grid filter popup from closing when highlighting text inside the filter input, and moving the cursor outside the popup
  private monitorGridFilterMenuForClickOutside() {
    this.singlePopupService.onClose.subscribe((e: PopupCloseEvent) => {
      const selection = window.getSelection();
      const textSelected = selection ? selection.toString() : '';

      if (textSelected.length > 0) {
        e.preventDefault();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/directives/kendo-grid-filter-menu-monitor.ts